module.exports = __webpack_public_path__ + "img/side-bar.8571045e.png";